// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ContractCreateController = function ($rootScope, $scope, $location, $routeParams, $http, $filter, Order, ProductInfo, nationalIdValidatorService,
    ProductPrices, PaymentMethod, PaymentMethodNames, CustomFieldSettings, Component, gettext, gettextCatalog,
    TimeGranularity, babelFilter, salesEntitiesService, PUtill, DatepickerUtils) {
    $scope.order = new Order();
    $scope.componentService = Component;
    $scope.order.cart = {
        Quantity: 1,
        MeteredUsages: [],
        ComponentSubscriptions: [],
        DiscountSubscriptions: [],
        RatedItems: [],
        StartDate: null
    };
    $scope.order.CustomerId = $routeParams.customerId;
    $scope.order.ContractCustomFields = {};
    $scope.order.AdditionalData = {};
    $scope.order.AdditionalData.Contract = {};
    $scope.order.AdditionalData.Contract.CustomFields = {};

    $scope.planGroupId = null;
    $scope.planId = null;
    $scope.priceListId = null;

    $scope.salesEntities = [];
    $scope.salesEntityId = null;
    $scope.salesEntityDefault = null;
    
    $scope.billedPeriods = 0;
    $scope.paymentMethodEnum = [];
    $scope.paymentMethod = null;
    $scope.paymentData = {};
    
    $scope.newMeteredUsage = {};
    $scope.newMeteredUsage.ProductOverride = {Name: "", Description: "", PricePerUnit: ""};
    $scope.newDiscountSubscription = {};
    
    $scope.newRatedItem = { Quantity: 1 };
    $scope.newComponentSubscription = { Quantity: 1 };
    $scope.newComponentSubscription.ProductOverride = {Name: "", Description: "", PricePerUnit: ""};
    
    $scope.saveClicked = false;
    $scope.opened = false;
    $scope.paymentTermInEditMode = false;

    function TrialMode(id, name){
        this.id = id;
        this.name = $filter('translate')(name);
    }

    $scope.trialModes = [
        new TrialMode("Enabled", "Enabled"),
        new TrialMode("Disabled", "Disabled"),
    ];

    $scope.trialMode = $scope.trialModes[0];

    salesEntitiesService.query({}, function (response) {
        $scope.salesEntities = response;
        $scope.salesEntityDefault = response.find(function (el) {
            return el.IsDefault == true;
        });

        if ($scope.salesEntityDefault) {
            let defaultSuffix = " (" + gettextCatalog.getString(gettext('default')) + ")";
            $scope.salesEntityDefault.InternalName += defaultSuffix;
            $scope.salesEntityId = $scope.salesEntityDefault.Id;
        }
    });

    $scope.newPaymentTerm = { Quantity: 1, Unit: PUtill.PeriodUnitMappings.Day.key };

    $scope.setPaymentTerm = function (value) {
        $scope.paymentTermSwitchOn = value;
    };

    $scope.isAvailableByFeature = function (featureName) {
        var value = $scope.features[featureName];
        return !!value;
    };
    
    $scope.isIBANValid = function(iban) {
        // IBAN validation is implemented in the iban.js
        return IBAN.isValid(iban);
    }

    $scope.isPaymentDataCorrectValidators = { 'iban': $scope.isIBANValid};

    $scope.modifyFieldView = function (fieldName, isValid) {
        let input = document.getElementById(fieldName);
        if (!input) {
            return;
        }
        // color comment
        // workaround for angularjs dropping ng-invalid
        // prolly due to child view and bad implementation
        if (isValid){
            input.classList.remove("ng-invalid");
            input.style.color = "#666";
            input.title = fieldName;
            input.removeAttribute('data-toggle');
        }
        else {
            input.classList.add("ng-invalid");
            input.style.color = "#b94a48";
            input.title = gettextCatalog.getString(gettext('Please check your input'));
            input.setAttribute('data-toggle', 'tooltip');
        }
    }

    function validateNationalId() {
        var countryCode = nationalIdValidatorService.getCountryCodeForPaymentMethod($scope.paymentMethod);
        return nationalIdValidatorService.isNationalIdValid(countryCode, $scope.paymentData.nationalIdNumber);
    }
    
    // if plan was changed then clear cart PlanVariantId
    $scope.$watch("planId", function () {
        $scope.order.cart.PlanVariantId = null;
    });
    
    // if PlanGroupId was changed then clear PlanId and cart PlanVariantId
    $scope.$watch("planGroupId", function () {
        $scope.planId = null;
        $scope.order.StartDate = null;
        
        if ($scope.order.cart) {
            $scope.order.cart.PriceListId = null;
            $scope.order.cart.PlanVariantId = null;
        }
        
        if ($scope.planGroupId) {
            $scope.disabledNowInDatePicker = $scope.productInfo.PlanGroupById($scope.planGroupId).TimeGranularity === TimeGranularity.Day;
        } else {
            $scope.disabledNowInDatePicker = false;
        }
    });

    $scope.$watch("order.cart.PlanVariantId", function () {
        if ($scope.order.cart?.PlanVariantId) {
            const selectedPlanGroup = $scope.productInfo.PlanGroupById($scope.planGroupId);
            $scope.order.cart.PriceListId = $scope.productInfo.PriceListsByPlanGroupId($scope.planGroupId).find(pl => pl.Id === selectedPlanGroup.DefaultPriceListId)?.Id;
        } else if ($scope.order.cart) $scope.order.cart.PriceListId = null;
    });

    $scope.$watch('order.StartDate', function () {
        $scope.order.BilledUntil = null;
        $scope.order.EndDate = null;
    }, true);

    $scope.$watch('paymentMethod', function (newValue) {
        if (newValue === "BlackLabel:InvoicePayment" || newValue === "OnAccount:PayOne" || newValue === "BlackLabel:SwanOnAccount") {
            $scope.selectedOnAccountPaymentMethod = true;
        } else {
            $scope.selectedOnAccountPaymentMethod = false;
        }
    }, true);

    $scope.$watch('paymentData.iban', function () {
        if ($scope.paymentData.iban) {
            $scope.paymentData.iban = $scope.paymentData.iban.replace(/\s/g, '').slice(0, 34).toUpperCase();
        }

        $scope.modifyFieldView('iban', $scope.isPaymentDataCorrectValidators['iban']($scope.paymentData.iban) );
    });

    $scope.$watch('paymentData.nationalIdNumber', function () {
        var isValid = validateNationalId();
        $scope.modifyFieldView('nationalIdNumber', isValid);
    });

    loadConfiguredPaymentMethods(function (paymentMethods) {
        $scope.paymentMethods = paymentMethods.paymentMethods;
        $scope.paymentMethodEnum = paymentMethods.paymentMethodEnum;
    });

    $scope.open = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        $scope.opened = true;
    };

    $scope.dateOptions = {
        'year-format': "'yy'",
        'starting-day': 1
    };

    function loadConfiguredPaymentMethods(callback) {
        PaymentMethod.query({ contractCreation: true }, function (data) {
            var result = { paymentMethods: data, paymentMethodEnum: [] };
            data.forEach(function (item) {
                result.paymentMethodEnum.push(item.Role + ":" + item.Provider);
            })
            callback(result);
        });
    };

    $scope.isNonMetered = function (elem) { return elem.ComponentType != 'Metered' && elem.PlanGroupId == $scope.planGroupId; };
    $scope.isMetered = function (elem) { return elem.ComponentType == 'Metered' && elem.PlanGroupId == $scope.planGroupId; };

    $scope.paymentMethodNamesEN = PaymentMethodNames.get();

    CustomFieldSettings.get({ customFieldType: 'Contract' }, function (data) {
        $scope.customFieldSettings = data.CustomFieldDescriptors;
    });
    
    $scope.productInfo = ProductInfo.get(function () {
        //get default TaxPolicy
        var defaultTaxPolicy = $scope.productInfo.TaxPolicies.getDefaultTaxPolicyId();
        //setup default TaxPolicy if exists
        if(defaultTaxPolicy) {
            $scope.newRatedItem = {Quantity: 1, TaxPolicyId: defaultTaxPolicy.Id};
        }
    }, false);

    $scope.isNewComponentSubscriptionRequired = false;
    $scope.addComponentSubscription = function () {
        $scope.newComponentSubscription.ProductOverride = SetupProductOverride($scope.newComponentSubscription.ProductOverride);
        if(!$scope.newComponentSubscription.ComponentId) {
            $scope.isNewComponentSubscriptionRequired = true;
        } else {
            $scope.order.cart.ComponentSubscriptions.push($scope.newComponentSubscription);
            $scope.newComponentSubscription = {Quantity: 1};
            $scope.isNewComponentSubscriptionRequired = false;
        }
        $scope.newComponentSubscription.ProductOverride = {Name: "", Description: "", PricePerUnit: ""};
    };

    $scope.isNewMeteredUsagRequired = false;
    $scope.addMeteredUsage = function () {
        $scope.newMeteredUsage.ProductOverride = SetupProductOverride($scope.newMeteredUsage.ProductOverride);
        if(!$scope.newMeteredUsage.ComponentId || $scope.newMeteredUsage.Quantity == null) {
            $scope.isNewMeteredUsagRequired = true;
        } else {
            $scope.order.cart.MeteredUsages.push($scope.newMeteredUsage);
            $scope.newMeteredUsage = {};
            $scope.isNewMeteredUsagRequired = false;
        }
        $scope.newMeteredUsage.ProductOverride = {Name: "", Description: "", PricePerUnit: ""};
    };

    $scope.isNewDiscountSubscriptionRequired = false;
    $scope.addDiscountSubscription = function () {
        if(!$scope.newDiscountSubscription.DiscountId) {
            $scope.isNewDiscountSubscriptionRequired = true;
        } else {
            $scope.order.cart.DiscountSubscriptions.push($scope.newDiscountSubscription);
            $scope.newDiscountSubscription = {};
            $scope.isNewDiscountSubscriptionRequired = false;
        }
    };
    $scope.isNewRatedItemRequired = false;
    $scope.addRatedItem = function () {
        if($scope.newRatedItem.Quantity == null || $scope.newRatedItem.TaxPolicyId == null) {
            $scope.isNewRatedItemRequired = true;
        } else {
            $scope.order.cart.RatedItems.push($scope.newRatedItem);
            $scope.newRatedItem = {Quantity: 1, TaxPolicyId: $scope.newRatedItem.TaxPolicyId};
            $scope.isNewRatedItemRequired = false;
        }
    };

    function isNewRatedItemNotEmpty() {
        var ratedItem = $scope.newRatedItem;
        return (ratedItem.Quantity != null && ratedItem.TaxPolicyId != null && (ratedItem.Description && ratedItem.Description.length > 0) && !isNaN(ratedItem.PricePerUnit));
    }

    $scope.deleteRatedItem = function (i) {
        $scope.order.cart.RatedItems.remove(i);
    };
    $scope.deleteComponent = function (hashKey) {
        $scope.order.cart.ComponentSubscriptions = $scope.order.cart.ComponentSubscriptions.filter(
            function (item) { return item.$$hashKey !== hashKey; });
    };
    $scope.deleteDiscount = function (hashKey) {
        $scope.order.cart.DiscountSubscriptions = $scope.order.cart.DiscountSubscriptions.filter(
            function (item) { return item.$$hashKey !== hashKey; });
    };

    $scope.deleteMetered = function (i) {
        $scope.order.cart.MeteredUsages.remove(i);
    };
    $scope.saveContract = function () {
        if ($scope.newPaymentTerm.Quantity === undefined || $scope.newPaymentTerm.Quantity < 0) {
            return;
        }
        // check if inputed data is valid
        if($scope.contractDetailsForm.$invalid) {
            $("#saveContractButton").click();
            return;
        }
        
        // check if IBAN is valid
        if($scope.paymentData.iban && !$scope.isIBANValid($scope.paymentData.iban)){
            alert(gettextCatalog.getString(gettext('IBAN is invalid. Please check your input')));
            return;
        }
        
        if ($scope.paymentData.MandateSignatureDate)
            $scope.paymentData.MandateSignatureDate = DatepickerUtils.backToBrowserTimezone($scope.paymentData.MandateSignatureDate);

        if ($scope.salesEntities.length > 1 && $scope.salesEntityId)
            $scope.order.SalesEntityId = $scope.salesEntityId;

        // if components or discount selected, ask client to add or discard the selected items
        if($scope.newDiscountSubscription.DiscountId || $scope.newComponentSubscription.ComponentId || $scope.newMeteredUsage.ComponentId  || isNewRatedItemNotEmpty()) {
            $scope.yesNoCancel(gettextCatalog.getString(gettext('Save Contract')),
                gettextCatalog.getString(gettext('Do you want to add the selected item before saving?')),
                function () {
                    if($scope.newDiscountSubscription.DiscountId) {
                        $scope.addDiscountSubscription();
                    }
                    if($scope.newComponentSubscription.ComponentId) {
                        $scope.addComponentSubscription();
                    }
                    if($scope.newMeteredUsage.ComponentId) {
                        $scope.addMeteredUsage();
                    }

                    if(isNewRatedItemNotEmpty()) {
                        $scope.addRatedItem();
                    }
                    $scope._saveContract();
                },
                function() {
                    $scope._saveContract();
                }
            );
        } else {
            $scope._saveContract();
        }
    };

    $scope._saveContract = function () {

        if ($scope.saveClicked)
            return;

        $scope.saveClicked = true;

        var cart = $scope.order.cart;

        if ($scope.selectedOnAccountPaymentMethod && $scope.paymentTermSwitchOn) {
            cart.OnAccountDueAfter = $scope.newPaymentTerm;
        }

        let plan = $scope.productInfo.PlanById($scope.planId);
        if (plan && !plan.IsQuantityBased)
            cart.Quantity = null;

        if (plan && plan.TrialPeriod && plan.TrialPeriod.Quantity !== 0){
            $scope.order.cart.Trial = $scope.trialMode.id;
        }

        $scope.order.BilledUntil = DatepickerUtils.backToBrowserTimezone($scope.order.BilledUntil);
        $scope.order.StartDate = DatepickerUtils.backToBrowserTimezone($scope.order.StartDate);
        $scope.order.EndDate = DatepickerUtils.backToBrowserTimezone($scope.order.EndDate);
        
        if (cart.ComponentSubscriptions && $scope.order.BilledUntil) {
            cart.ComponentSubscriptions.forEach(function(item){
                item.BilledUntil = $scope.order.BilledUntil;
            });
        }
        
        $scope.orderCopy = angular.copy($scope.order);

        $scope.order.$save({}, function (data) {
            $http({
                method: "POST", url: "/api/v1/orders/" + data.Id + "/commit", params: null,
                data: { paymentMethod: $scope.paymentMethod, bearer: GetBearer() }, headers: { "Content-Type": "application/json" }, cache: false
            }).then(function (response) {
                var dto = response.data;
                if (dto.Status === "ApprovalPending") {
                    $location.path("/logs/orders/" + dto.Id);
                } else {
                    $location.path("/contracts/" + dto.Id);
                }

                },
                function () {
                //this is not needed
                //$scope.back();
                $scope.saveClicked = false;
                $scope.order = angular.copy($scope.orderCopy);
            });
        }, function () {
            $scope.saveClicked = false;
        });
    };

    $scope.isQuantityBase = function () {
        return $scope.newComponentSubscription.ComponentId && ($scope.productInfo.ComponentById($scope.newComponentSubscription.ComponentId).ComponentType == 'QuantityBased');
    };

    CustomFieldSettings.get({ customFieldType: 'Contract' }, function (data) {
        $scope.customFieldSettings = data.CustomFieldDescriptors;
    });

    $scope.ResetComponentSubscriptionProductOverride = function () {
        $scope.newComponentSubscription.ProductOverride = {Name: "", Description: "", PricePerUnit: ""};
    }

    $scope.ResetMeteredUsageProductOverride = function () {
        $scope.newMeteredUsage.ProductOverride = {Name: "", Description: "", PricePerUnit: ""};
    }

    $scope.GetComponentName = function (baseComponent, newComponent) {
        const isOverrideNameExist = baseComponent.Id &&
            newComponent &&
            baseComponent.Id === newComponent.ComponentId &&
            newComponent.ProductOverride.Name &&
            newComponent.ProductOverride.Name !== "";
        if(isOverrideNameExist) {
            return `${baseComponent.ExternalId} ${newComponent.ProductOverride.Name} - ${babelFilter(baseComponent.Name)}`
        }
        return `${baseComponent.ExternalId} ${babelFilter(baseComponent.Name)}`
    }

    $scope.isNationalIdNumberVisible = function () {
        return $scope.paymentMethod === 'Autogiro:PayExInvoiceService';
    }

    $scope.isDebit = function() {
        return $scope.paymentMethod === 'Debit:Paymill' ||
            $scope.paymentMethod === 'Debit:PayOne' ||
            $scope.paymentMethod === 'Debit:FakeProvider' ||
            $scope.paymentMethod === 'Debit:Wirecard' ||
            $scope.paymentMethod === 'Debit:SepaXml' ||
            $scope.paymentMethod === 'Debit:GoCardless' ||
            $scope.paymentMethod === 'Debit:Mollie' ||
            $scope.paymentMethod === 'Debit:UnzerV2';
    }

    const SetupProductOverride = function (productOverride) {
        if (!productOverride) return productOverride;
        
        if (productOverride.Name === "" &&
            productOverride.PricePerUnit === "" &&
            productOverride.Description === "") {
            productOverride = null;
        }
        if (productOverride && productOverride.Name === "") {
            delete productOverride.Name;
        }
        if (productOverride && productOverride.pricePerUnit === "") {
            delete  productOverride.PricePerUnit;
        }
        if (productOverride && productOverride.Description === "") {
            delete productOverride.Description;
        }
        return productOverride;
    }

    $scope.isPriceListDisabled = function(priceList)
    {
        if (!priceList?.Items || !$scope.order.cart?.PlanVariantId)
            return true;

        let price = priceList.Items.find(item => item.ProductId === $scope.order.cart.PlanVariantId)
            || priceList.ParentItems?.find(item => item.ProductId === $scope.order.cart.PlanVariantId);
        return price?.OneOffPrice == null || price?.RecurringPrice == null;
    }

    //TODO N.C. : info is this debit or not should come from services.js or come from BE.
    const GetBearer = function ()
    {
        const paymentMethodInLowerCase = $scope.paymentMethod.toLowerCase();
        const isDebit = paymentMethodInLowerCase.startsWith("debit:") ||
            paymentMethodInLowerCase.startsWith("autogiro") ||
            paymentMethodInLowerCase.startsWith("avtalegiro");
        
        return isDebit ? $scope.paymentData : null; 
    }
};
ContractCreateController.$inject = ['$rootScope', '$scope', '$location', '$routeParams', '$http', '$filter', 'Order', 'ProductInfo', 'nationalIdValidatorService',
    'ProductPrices', 'PaymentMethod', 'PaymentMethodNames', 'CustomFieldSettings', 'Component', 'gettext',
    'gettextCatalog', 'TimeGranularity', 'babelFilter', 'SalesEntities', 'PUtill', 'DatepickerUtils'];
